import { useEffect } from "react";
import {
  Env,
  logAppVersion,
  getAppName,
  setAppVersionForAppMonitoring,
} from "../services";

const shownMap = {};

export const useLogAppVersion = (appEnv: Env): void => {
  useEffect(() => {
    // Disable when testing
    if (appEnv.NODE_ENV === "TEST") {
      return;
    }

    const appName = getAppName(appEnv);

    setAppVersionForAppMonitoring(appEnv);

    // Verify only shown once per app
    if (shownMap[appName]) {
      return;
    }
    shownMap[appName] = true;

    logAppVersion(appEnv);

    // Only run once. `appEnv` (which is `process.env`) is a new value on every
    // render for some reason.
  }, []);
};
